import { render } from "./GridSalesSources.vue?vue&type=template&id=221a0509&scoped=true&ts=true"
import script from "./GridSalesSources.vue?vue&type=script&lang=ts"
export * from "./GridSalesSources.vue?vue&type=script&lang=ts"

import "./GridSalesSources.vue?vue&type=style&index=0&id=221a0509&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-221a0509"]])

export default __exports__